import { Directive } from '@angular/core';

@Directive({
  selector: '[appFormControlHint]',
  standalone: true,
})
export class FormControlHintDirective {}
